// extracted by mini-css-extract-plugin
export default {"titleInput":"main_titleInput__wlMOh"};